(function () {
	'use strict';

	a3_cabin_reports.service("PushNotifier", PushNotifier);

    /**
    * @memberof CabinReports
    * @ngdoc service
    * @name PushNotifier
    * @description 
    *  Push notification functionality
    * @ngInject
    */
	function PushNotifier($q, FlightFactory, PaxInfoFactory) {

		var service = {
			Generate: Generate,
			formatInfoToCompare: formatInfoToCompare,
			compareAndExtractChanges: compareAndExtractChanges,
			MessageGenerator: BodyGenerator,
			CheckForPermissionsAndSupport: CheckForPermissionsAndSupport
		}


		var browserSupportsNotifications = ("Notification" in window);

		function CheckForPermissionsAndSupport() {

			var deferred = $q.defer();

			// Let's check if the browser supports notifications
			if (!browserSupportsNotifications) {
				console.debug("This browser does not support system notifications");
				deferred.resolve(false);
			}

			// // Otherwise, we need to ask the user for permission
			if (browserSupportsNotifications && Notification.permission !== 'denied') {

				var permissionQ = Notification.requestPermission();
                
                if (permissionQ){
                        permissionQ.then(function (result) {
                            var value = (result === "granted");

                            deferred.resolve(value);
                        }), function (reason) {
                            LogService.error(reason);
                            deferred.reject(reason);
                        };
                }else{
                    deferred.resolve(false);
                }
                
			}else {
                deferred.resolve(false);
            }
            
			return deferred.promise;
		}


		function Generate(title, body) {

			// Let's check whether notification permissions have already been granted
			if (browserSupportsNotifications && Notification.permission === "granted") {
				// If it's okay let's create a notification
				var notification = new Notification(title, { body: body, icon: './img/a3_logo.png' });
				setTimeout(function () {
					notification.close();
				}, 5000);
			}
		}

		function formatInfoToCompare(flightId) {

			var flightInfo = FlightFactory.getFlightFromStorage(flightId);

			var data = {
				CTOT: flightInfo.CTOT,
				ATD: flightInfo.ATD,
				ETA: flightInfo.ETA,
				ETD: flightInfo.ETD
			};

			data['Departure Gate'] = flightInfo.DepartureGate;
			data['Departure Stand'] = flightInfo.DepartureStand;
			data['Scheduled Departure Time UTC'] = flightInfo.ScheduledDepartureTimeUTC;

			var deferred = $q.defer();

			PaxInfoFactory.getPaxInfoFromStorage(flightId, function (paxinfo) {
				data['Passenger Info'] = paxinfo ? moment.utc(paxinfo.LastRun).format('dd-MM-yyyy HH:mm') : null;
				deferred.resolve(data);
			});

			return deferred.promise;
		}

		function compareAndExtractChanges(currentData, updatedData) {
			var changes = [];
			for (var key in currentData) {
				if (currentData[key] != updatedData[key]) {

					var ovalue = currentData[key];
					var nvalue = updatedData[key];

					if (key === "CTOT" || key === "ATD" || key === "ETA" || key === "ETD" || key === "Scheduled Departure Time UTC") {
						if (currentData[key] != null) {
							ovalue = moment.utc(currentData[key]).format('HH:mm')
						}

						if (updatedData[key] != null) {
							nvalue = moment.utc(updatedData[key]).format('HH:mm')
						}
					}

					changes.push({ type: key, oldValue: ovalue, newValue: nvalue });
				}
			}
			return changes;
		}
		function BodyGenerator(changes) {
			var message = '';
			changes.forEach(function (x) {
				var phrase = null;

				if (x.type == 'Passenger Info') {
					phrase = "Passenger Info have been updated. \n";
				}
				else if (!x.oldValue) {
					phrase = x.type + ": " + x.newValue + " \n";
				} else if (x.oldValue && x.newValue) {
					phrase = x.type + ": " + x.oldValue + "\u2192" + x.newValue + " \n";
				} else {
					phrase = x.type + " has no value\n";
				}

				message = message + phrase;
			});

			return message;
		}

		return service;
	}
})();
